import { render, staticRenderFns } from "./fangdichan.vue?vue&type=template&id=198b3854&scoped=true&"
import script from "./fangdichan.vue?vue&type=script&lang=js&"
export * from "./fangdichan.vue?vue&type=script&lang=js&"
import style0 from "./fangdichan.vue?vue&type=style&index=0&id=198b3854&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b3854",
  null
  
)

export default component.exports